import { render, staticRenderFns } from "./ReturnPartsListSideMenu.vue?vue&type=template&id=5a579b9b&scoped=true"
import script from "./ReturnPartsListSideMenu.vue?vue&type=script&lang=js"
export * from "./ReturnPartsListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./ReturnPartsListSideMenu.vue?vue&type=style&index=0&id=5a579b9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a579b9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a579b9b')) {
      api.createRecord('5a579b9b', component.options)
    } else {
      api.reload('5a579b9b', component.options)
    }
    module.hot.accept("./ReturnPartsListSideMenu.vue?vue&type=template&id=5a579b9b&scoped=true", function () {
      api.rerender('5a579b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsListSideMenu.vue"
export default component.exports